import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AppService } from '@core/services/app.service';
import { ITesis } from '@shared/models/interfaces';

@Component({
  selector: 'app-facilities-item',
  templateUrl: './facilities-item.component.html',
  styleUrls: ['./facilities-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FacilitiesItemComponent implements OnInit {
  public tesisler: ITesis[];

  @Input() type = 'dropdown-item | list-item';
  @Input() selectedFac: number;

  constructor(
    private appService: AppService,
  ) { }

  ngOnInit(): void {
    this.getTesis();
  }

  getTesis() {
    this.appService.getTesisList$().subscribe(response => {
      this.tesisler = response;
    });
  }
}
